import { gql } from '@apollo/client'

export const CLEAR_CORPORATION_CACHE = gql`
  mutation CLEAR_CORPORATION_CACHE($corporationId: ID!) {
    clearCorporationCache(corporationId: $corporationId)
  }
`
